export const hostSignupTypeform = "https://popperi.typeform.com/to/xrhR9c";
export const vendorOnlinePopupTypeform = "https://popperi.typeform.com/to/UCDRLN";
export const customerTypeform = "https://popperi.typeform.com/to/rUUatJ";
export const twitterURL = "http://twitter.com/PopperiPopups";
export const facebookURL = "http://facebook.com/PopperiPopups";
export const instagramURL = "http://instagram.com/popperipopups";